import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=2c4a0d81&scoped=true&"
import script from "./VerticalSlider.vue?vue&type=script&lang=js&"
export * from "./VerticalSlider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSlider.vue?vue&type=style&index=0&id=2c4a0d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a0d81",
  null
  
)

export default component.exports